import { createStore } from '@stencil/store';
import { PersonDoc } from 'common';
import { TeamDoc } from '../service/PeopleService';

export interface PeopleStoreState {
  loading: boolean;
  people: PersonDoc[];
  teams: TeamDoc[];
  projectId: string | null;
}

const initialStoreState: PeopleStoreState = {
  // false: we only set loading=true when PouchDB has no cached people (first visit)
  loading: false,
  people: [],
  teams: [],
  projectId: null,
};

export const { state: peopleState, onChange: peopleStoreOnChange, dispose: disposePeopleStore } = createStore<PeopleStoreState>(initialStoreState);

export const setPeopleStoreLoading = (loading: boolean) => {
  peopleState.loading = loading;
};

// Helper functions to update store
export const setPeopleStorePeople = (people: PersonDoc[]) => {
  peopleState.people = people;
};

export const setPeopleStoreTeams = (teams: TeamDoc[]) => {
  peopleState.teams = teams;
};

export const setPeopleStoreProjectId = (projectId: string | null) => {
  peopleState.projectId = projectId;
};

// Teams live in the same PouchDB as people. Called from app-root only.
export const applyPeopleDocs = (projectId: string, docs: any[]) => {
  peopleState.projectId = projectId;
  peopleState.people = docs.filter(doc => doc.type !== 'team');
  peopleState.teams = docs.filter(doc => doc.type === 'team');
  peopleState.loading = false;
};

export const resetPeopleStore = () => {
  peopleState.people = [];
  peopleState.teams = [];
  peopleState.projectId = null;
  peopleState.loading = false; // don't carry a loading spinner into the next project
};
